import { combineReducers } from "redux";

/**
 * Reducers
 */
import vida from "./vida";
import plans from "./plans";
import global from "./global";
import dps from "./dps";
import beneficiaries from "./beneficiaries";
import domicilio from "./domicilio";
import auditoria from "./auditoria";
import jobs from "./jobs";
import modalExit from "./modalExit";
import modalValuesTable from "./modalValuesTable";
import token from "./token";
import trip from "./trip";
import experimentReducer from "./experiment";
import dynamicContentReducer from "./dynamicContent";

const appReducer = combineReducers({
  global,
  domicilio,
  dps,
  vida,
  plans,
  beneficiaries,
  auditoria,
  jobs,
  modalExit,
  modalValuesTable,
  token,
  trip,
  experiment: experimentReducer,
  dynamicContent: dynamicContentReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGGED_OUT") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
